<template>
    <footer id="site-footer" class="site-footer">
        <div class="site-footer-inner">
            <content-caddy-footer :content="footerCaddy" class="grid container flex"><div class="footer-logo"><LogoButton /></div></content-caddy-footer>
            <div class="container copyright">
                <p>&copy; {{ year }} Owen Associates Interiors. <a href="/cookies-privacy">Cookies &amp; Privacy</a></p>
            </div>
        </div>
    </footer>
</template>

<script lang="js">
    import { mapGetters } from 'vuex'
    import LogoButton from './LogoButton.vue'
    import ContentCaddyFooter from '../content/footer/ContentCaddy.vue'

    export default {
        name: "the-footer",
        mounted() {
            // Get the main links
            this.$store.dispatch('content/getCaddy', { id: 3779, name: "footerCaddy" });
        },
        components: {
            LogoButton,
            ContentCaddyFooter
        },
        data() {
            return {
                year: new Date().getFullYear()
            };
        },
        computed: {
            ...mapGetters({ caddyByName: 'content/caddyByName' }),
            footerCaddy() {
                if (!this.caddyByName('footerCaddy')) return null;
                // The above is called first so at this point the footerCaddy will no longer contain the FAQs as shift will have removed them.
                return this.caddyByName('footerCaddy');
                //return this.caddyByName('footerCaddy');
            }
        }
    };
</script>

<style>
    .site-footer {
        position: relative;
        z-index: 1;
    }

    .site-footer .site-footer-inner {
        background-color: var(--green1);
        color: var(--white1);
        text-align: center;
    }

    .site-footer .container {
        position: relative;
        z-index: 2;
        padding: 2rem 1rem;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

        .site-footer .footer-logo {
            margin: 0 auto 1em auto;
            display: block;
            flex-basis: 100%;
        }
            .site-footer .footer-logo a {
                margin: 0 auto;
            }

    .site-footer .container h1 {
        font-size: var(--font-size-4);
        font-weight: 700;
    }

    .site-footer .copyright {
        align-items: center;
        justify-content: center;
        padding-top: 0;
    }
        .site-footer .copyright > * {
            font-size: var(--font-size-0);
            font-weight: 300;
        }
        .site-footer .copyright a {
            color: #fff;
            text-decoration: none;
            display: inline-block;
        }
            .site-footer .copyright a:hover {
                text-decoration: underline;
            }

    @media screen and (min-width: 800px) {
        .site-footer .container.flex {
            justify-content: flex-start;
            align-items: center;
        }

        .site-footer .logocopy > h2 {
            font-size: var(--font-size-6);
            line-height: 2.3125rem;
            flex-basis: auto;
            margin-bottom: 0;
            margin-left: 3rem;
        }

        .site-footer .container.flex .copy-links {
            justify-content: flex-end;
            margin-top: 1rem;
        }
    }

    /* Content Caddies */

    .site-footer .grid {
        padding: 2em 1em;
    }

    @media screen and (min-width: 800px) {
        .site-footer .grid {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-template-rows: 1fr auto;
            column-gap: 1.25em;
            row-gap: 0.625em;
            padding-left: 1.5em;
            padding-right: 1.5em;
        }
    }

</style>